export const HABILITADO_SUCESSO = 'Registros habilitado com sucesso.';
export const DESABILITADO_SUCESSO = 'Registro desabilitado com sucesso.';
export const ATUALIZADOS_SUCESSO = 'Registros alterados com sucesso.';
export const ATUALIZADO_SUCESSO = 'Registro alterado com sucesso.';
export const REGISTRO_ASSOCIADO_SUCESSO = 'Registro associado com sucesso.';
export const CADASTRADO_SUCESSO ='Registro incluído com sucesso.';
export const CADASTRADOS_SUCESSO = 'Registros incluídos com sucesso.';
export const EXCLUIDO_SUCESSO = 'Registro removido com sucesso.';
export const EXCLUIDOS_SUCESSO = 'Registros removidos com sucesso.';
export const REGISTRO_DESASSOCIADO_SUCESSO = 'Registro desassociado com sucesso.';
export const GERACAO_SUCESSO = 'Geração concluída com sucesso.';
export const IMPORTACAO_SUCESSO = 'Importação concluída com sucesso.';
export const ANULACAO_SUCESSO = 'Anulação concluída com sucesso.';
export const NAO_PODE_EDITAR = "Registro não pode ser editado";
export const CPFINVALIDO = 'CPF inválido.';
export const REGISTRO_NAO_ENCONTRADO = "Registro não encontrado.";
export const CONFIRMA_DELETE = "Deseja realmente remover o registro?";
export const CONFIRMA_OPERACAO = "Deseja realmente realizar esta operação?";
export const SELECIONAR_REGISTRO = 'É necessário selecionar ao menos um registro para executar esta ação.';
export const DESATIVADO_SUCESSO = 'Registro desativado com sucesso.';
export const ATIVADO_SUCESSO = 'Registro ativado com sucesso.';
export const NAO_EDITAVEL = 'Não é permitido Alterar este Registro.';
export const DESASSOCIAR_REGISTRO = 'Deseja realmente desassociar este registro?';
export const CONFIRMA_DESASSOCIAR = "Deseja realmente desassociar o registro?";
export const ASSOCIADO_SUCESSO = item => _replace("{0} associado com sucesso.", item);
export const DESASSOCIADO_SUCESSO = item => _replace("{0} desassociado com sucesso.", item);

function _replace(message, parameters) {
    for(var i = 0; i < parameters.length; i++){
        message = message.replace("{" + i + "}", parameters[i]);
    }

    return message;
}
